import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray, convertStringToArrayForOption } from '../../../../utils';
//rest client
import { eapiClient } from '../../../../restClient';
// action creator
import { setAdminTabIndex } from '../../actions/actionCreator';
// children
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../common/Modal';
import Filter from './Grid/Filter';
import ReactTable from './Grid/Table/';

// css
import './style.css';

const validate = (caseId) => {
  return {
    caseId: caseId.length === 0
  };
}

class UserAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.GridData.data,
      filterData: [],
      roleFilter: null,
      approverFilter: null,
      showUnlockModal: false,
      showChangeStatusModal: false,
      caseId: '',
      touched: {
        caseId: false,
      },
      errMsg: false,
      arrowIsOpen: false,
      display: 'none'
    };
  }

  handleBlur = field => evt => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  checkValue = (name) => {
    if (name ? this.state[name] && this.state[name].length === 0 : this.state.caseId.length === 0) {
      this.setState({
        errMsg: false
      })
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    }, () => this.checkValue(event.target && event.target.name));
  }

  componentDidMount() {
    this.props.setAdminTabIndex(0);
    window.addEventListener('click', this.handleWindowClick)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  }

  handleWindowClick = () => {
    this.setState({
      display: 'none',
      arrowIsOpen: false
    });
  }

  //obj.entityName.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1)
  searchItmeHander = (str) => {
    if (this.props.GridData.data.length > 0) {
      let filterobject = this.props.GridData.data.filter(obj => {
        if (typeof obj.name !== 'undefined' && obj.name.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1) {
          return obj
        } else if (typeof obj.userGroupsData !== 'undefined' && obj.userGroupsData.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1) {
          return obj
        }
      });

      this.setState({
        data: filterobject
      })
    } else {
      let filterobject = this.props.GridData.data.filter(obj => {
        if (typeof obj.userGroupsData !== 'undefined' && obj.userGroupsData.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1)
          return obj
      });

      this.setState({
        data: filterobject
      })
    }
  }

  getRoleStatusOnchange = (statusStr) => {
    let approverFilter = this.state.approverFilter;
    if (statusStr.length > 0 && statusStr !== 'All roles') {
      let filterobject = this.props.GridData.data.filter(function (obj) {
        if (approverFilter) {
          if (obj.role !== undefined && obj.role.name === statusStr && obj.glsApproverData === approverFilter) {
            return obj;
          }
        }
        else if (obj.role !== undefined && obj.role.name === statusStr) {
          return obj;
        }
      });

      this.setState({
        filterData: filterobject,
        data: filterobject,
        roleFilter: statusStr,
        approverFilter: approverFilter
      });
    } else {
      if (approverFilter && statusStr !== "") {
        let filterobject = this.props.GridData.data.filter(function (obj) {
          if (obj.glsApproverData === approverFilter) {
            return obj;
          }
        });

        this.setState({
          filterData: filterobject,
          data: filterobject
        });
      }
      else {

        this.setState({
          filterData: this.props.GridData.data,
          data: this.props.GridData.data,
          roleFilter: null
        });
      }
    }
  }

  getApproverStatusOnchange = (statusStr) => {
    let roleFilter = this.state.roleFilter;
    if (statusStr.length > 0 && statusStr !== 'All') {
      let filterobject = this.props.GridData.data.filter(function (obj) {
        if (roleFilter) {
          if (obj.glsApproverData === statusStr && obj.role !== undefined && obj.role.name === roleFilter) {
            return obj;
          }
        }
        else if (obj.glsApproverData === statusStr) {
          return obj;
        }
      });

      this.setState({
        filterData: filterobject,
        data: filterobject,
        approverFilter: statusStr,
        roleFilter: roleFilter
      });
    }
    else {
      if (roleFilter && statusStr !== "") {
        let filterobject = this.props.GridData.data.filter(function (obj) {
          if (obj.role !== undefined && obj.role.name === roleFilter) {
            return obj;
          }
        });

        this.setState({
          filterData: filterobject,
          data: filterobject
        });
      }
      else {
        this.setState({
          filterData: this.props.GridData.data,
          data: this.props.GridData.data,
          approverFilter: null
        });
      }
    }
  }

  dummyRole = (status) => {
    switch (status) {
      case 'Initial request incomplete':
        return true;
        break;
      case 'Initial request, data ready':
        return true;
        break;
      case 'Documentation draft':
        return false;
        break;
      case 'Documentation, awaiting signature':
        return true;
        break;
      case 'Awaiting activation':
        return true;
        break;
      case 'Case complete':
        return false;
        break;
      case 'Cancelled':
        return false;
        break;
      default:
        return false;
    }
  }
  columnsHeader = () => {
    let optionsData;
    let columns = []
    var options = Translations(this.props.pageJson.table_adminList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData);
    var ids = this.props.pageJson.table_adminList.fields;
    optionsData = convertStringToArray(options)
    ids.map((item, index) => {
      columns.push({
        accessor: item,
        Header: optionsData[index]
      })

    })
    return columns;
  }
  rowLink = (data) => {
    if (this.props.rowLinkAllCases) {
      this.props.rowLinkAllCases(data)
    }
  }

  resetAll = () => {
    this.setState({
      data: this.props.GridData.data
    })
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  convertStringToArrayForOptions = (options) => {
    return convertStringToArrayForOption(this.translations(options));
  }
  exportUserList = (list, data) => {
    var Url, fileName;
    if (list === 'UserList') {
      Url = `/users/downloadReport`
      fileName = `user-list.xlsx`
    } else if (list === 'MiReport') {
      if (data.target.innerText === 'MI report') {
        Url = `cases/download-report`
        fileName = `Generate-MI-Report.xlsx`
      } else if (data.target.innerText === 'Data disposition report') {
        Url = `users/download-dd-report?delta=false`
        fileName = `Generate-DD-Report.xlsx`
      } else if (data.target.innerText === 'Delta run report') {
        Url = `users/download-dd-report?delta=true`
        fileName = `Generate-DD-Delta-Report.xlsx`
      } else if (data.target.innerText === 'Cost Allocation Matrix') {
        Url = `users/cognosReport/getFile?fileName=CostAllocationMatrix`
        fileName = `CostAllocationMatrix.xlsx`
      } else if (data.target.innerText === 'Customer Database Mongodb Data') {
        Url = `users/cognosReport/getFile?fileName=CustomerDatabaseMongodbData`
        fileName = `CustomerDatabaseMongodbData.xlsx`
      } else if (data.target.innerText === 'Portico Report Pack And Business Segment') {
        Url = `users/cognosReport/getFile?fileName=PorticoReportPackAndBusinessSegment`
        fileName = `PorticoReportPackAndBusinessSegment.xlsx`
      } else if (data.target.innerText === 'Cognos Report') {
        Url = `users/cognosReport/getFile?fileName=full`
        fileName = `CognosReport.xlsx`
      }
    }

    eapiClient(Url, {
      method: 'GET',
      responseType: 'blob',
    })
      .then((response, filename, mime) => {
        var blob = new Blob([response.data], { type: mime || 'application/vnd.ms-excel' });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were
          // revoked by closing the blob for which they were created.
          // These URLs will no longer resolve as the data backing
          // the URL has been freed."
          window.navigator.msSaveBlob(blob, fileName);
        }
        else {
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', fileName);

          // Safari thinks _blank anchor are pop ups. We only want to set _blank
          // target if the browser does not support the HTML5 download attribute.
          // This allows you to download files in desktop safari if pop up blocking
          // is enabled.
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      });
  }

  createUser = () => {
    this.props.history.push('/admin-panel/create-user/')
  }

  createCase = () => {
    this.props.history.push('/admin-panel/create-edit-case/')
  }

  unlockCaseDialog = () => {
    this.setState({
      showUnlockModal: true
    })
  }

  changeCaseStatusDialog = () => {
    this.setState({
      showChangeStatusModal: true
    })
  }

  toggleUnlockModal = () => {
    this.setState(prevState => ({
      showUnlockModal: false,
      touched: {
        caseId: !prevState.touched.caseId,
      },
      errMsg: false,
      caseId: ''
    }))
  }

  toggleChangeStatusModal = () => {
    this.setState(prevState => ({
      showChangeStatusModal: false,
      touched: {
        caseId: !prevState.touched.caseId,
      },
      errMsg: false,
      caseId: ''
    }))
  }

  submitUnlockData = () => {
    eapiClient(`/cases/${this.state.caseId}/unlock-case`, {
      method: 'PUT',
    }).then(({ data, response }) => {
      this.setState({
        errMsg: false,
      })
      this.toggleUnlockModal()
    }).catch(({ response }) => {
      console.log('ERROR:', response);
      if (response.status === 404) {
        this.setState({
          errMsg: true,
          touched: {
            caseId: false,
          }
        })
      }
    })
  }

  submitCaseChangeStatus = () => {
    eapiClient(`/cases/${this.state.caseId}/change-case-status`, {
      method: 'PUT',
    }).then(({ data, response }) => {
      this.setState({
        errMsg: false,
      })
      this.toggleChangeStatusModal()
    }).catch(({ response }) => {
      console.log('ERROR:', response);
      if (response.status === 404) {
        this.setState({
          errMsg: true,
          touched: {
            caseId: false,
          }
        })
      }
    })
  }

  _openHander = (e) => {
    e.stopPropagation();
    let _state = this.state;
    if (this.state.arrowIsOpen === true && this.state.display === 'block') {
      _state['arrowIsOpen'] = false;
      _state['display'] = 'none';
      this.setState(_state);
    } else {
      _state['arrowIsOpen'] = true;
      _state['display'] = 'block';
      this.setState(_state);
    }

  }

  _openHander = (e) => {
    e.stopPropagation();
    let _state = this.state;
    if (this.state.arrowIsOpen === true && this.state.display === 'block') {
      _state['arrowIsOpen'] = false;
      _state['display'] = 'none';
      this.setState(_state);
    } else {
      _state['arrowIsOpen'] = true;
      _state['display'] = 'block';
      this.setState(_state);
    }
  }

  submitSowUnlockData = () => {
    const apiUrl = "/sows/" + this.state[this.props.unlockSowModalJson.name] + "/unlockSow"
    eapiClient(apiUrl, {
      method: 'PUT',
    }).then(({ data, response }) => {
      this.setState({
        errMsg: false,
      })
      this.toggleUnlockSowModal()
    }).catch(({ response }) => {
      console.log('ERROR:', response);
      if (response.status === 404) {
        this.setState({
          errMsg: true,
          touched: {
            [this.props.unlockSowModalJson.name]: false,
          }
        })
      }
    })
  }

  toggleUnlockSowModal = () => {
    this.setState(prevState => ({
      showUnlockSowModal: false,
      touched: {
        [this.props.unlockSowModalJson.name]: !prevState.touched[this.props.unlockSowModalJson.name],
      },
      errMsg: false,
      [this.props.unlockSowModalJson.name]: ''
    }))
  }

  unlockSowDialog = () => this.setState({
    showUnlockSowModal: true
  })

  render() {
    const errors = validate(this.state.caseId);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    const displayError = field => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];

      return hasError ? shouldShow : false;
    };
    const options = this.convertStringToArrayForOptions(this.props.pageJson.guidedropdownlist_genReports.options)
    const display = {
      display: this.state.display
    }
    return (
      <div className="gdoc-caselist-grid" >
        <div className="create-group-section">
          <button
            className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.exportUserList.bind(this, "UserList")}
          >
            {this.translations(this.props.pageJson.button_exportUserList.text)}
          </button>
        </div>
        <div className="create-group-section">
          <button
            className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.createUser}
          >
            {this.translations(this.props.pageJson.table_adminList.addUser)}
          </button>
        </div>
        <div className="create-group-section">
          <div className="create-group-btn-export gdoc-mbottom-10" onClick={(event) => this._openHander(event)}>
            <span className="gdoc-addproduct-selected-country">
              <span className="gdoc-addproduct-plussign">{this.translations(this.props.pageJson.guidedropdownlist_genReports.title)}</span>
            </span>
            <i className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up  gdoc-addproduct-icondown' : 'icon icon-chevron-down gdoc-addproduct-icondown'}></i>
            <ul id="gdoc-addproduct-select-lng" className="gdoc-addproduct-custom-dropdown" style={display}>
              {options.length > 0 ? Object.keys(options).map((key) => <li key={key} onClick={this.exportUserList.bind(this, 'MiReport')}>{options[key].split('=')[1]}</li>) : ''}
            </ul>
          </div>
        </div>

        <div className="create-group-section">
          <button className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.unlockSowDialog}>
            {this.translations((this.props.pageJson && this.props.pageJson.table_adminList && this.props.pageJson.table_adminList.unlockSow) || "Unlock SOW")}
          </button>
        </div>

        <div className="create-group-section">
          <button
            className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.unlockCaseDialog}
          >
            {this.translations(this.props.pageJson.table_adminList.unlockCase)}
          </button>
        </div>
        <div className="create-group-section">
          <button
            className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.changeCaseStatusDialog}
          >
            {this.translations(this.props.pageJson.table_adminList.changeCaseStatus)}
          </button>
        </div>
        {this.props.pageJson.button_createEditCase !== undefined ? <div className="create-group-section">
          <button
            className="create-group-btn-export gdoc-mbottom-10"
            onClick={this.createCase}
          >
            {this.translations(this.props.pageJson.button_createEditCase.text)}
          </button>
        </div> : ''}
        <Modal show={this.state.showChangeStatusModal} onClose={this.toggleChangeStatusModal} bsClass="delete-group-model">
          <ModalHeader title={this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusScreenHeading)} />
          <ModalBody>
            <div className="unlock-section">
              <div className="field_row">
                <label className="label-container">
                  {this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusCaseId)}
                </label>
                <div className="field-container">
                  <input
                    className=""
                    type="text"
                    name="caseId"
                    onBlur={this.handleBlur('caseId')}
                    value={this.state.userName}
                    onChange={this.handleChange}
                  />
                  {
                    displayError("caseId") ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusCaseIdErrorMessage)}
                      </div>
                    ) : ''
                  }
                  {
                    this.state.errMsg ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusScreenOnlyNumbers)}
                      </div>
                    ) : ''
                  }
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="delete-group-model--body">
              <div className="gdocs-float-left">
                <button className="gdocs-btn-delete" onClick={this.toggleChangeStatusModal}>
                  {this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusScreenCancel)}
                </button>
              </div>
              <div className="gdocs-float-right">
                <button className="gdocs-btn" onClick={this.submitCaseChangeStatus} disabled={isDisabled}>
                  {this.translations(this.props.unlockPageJson.static_text_changeCaseStatusScreen.changeCaseStatusScreenSave)}
                </button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
        <Modal show={this.state.showUnlockModal} onClose={this.toggleUnlockModal} bsClass="delete-group-model">
          <ModalHeader title={this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseScreenHeading)} />
          <ModalBody>
            <div className="unlock-section">
              <div className="field_row">
                <label className="label-container">
                  {this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseId)}
                </label>
                <div className="field-container">
                  <input
                    className=""
                    type="text"
                    name="caseId"
                    onBlur={this.handleBlur('caseId')}
                    value={this.state.userName}
                    onChange={this.handleChange}
                  />
                  {
                    displayError("caseId") ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseIdErrorMessage)}
                      </div>
                    ) : ''
                  }
                  {
                    this.state.errMsg ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseScreenOnlyNumbers)}
                      </div>
                    ) : ''
                  }
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="delete-group-model--body">
              <div className="gdocs-float-left">
                <button className="gdocs-btn-delete" onClick={this.toggleUnlockModal}>
                  {this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseScreenCancel)}
                </button>
              </div>
              <div className="gdocs-float-right">
                <button className="gdocs-btn-primary" onClick={this.submitUnlockData} disabled={isDisabled}>
                  {this.translations(this.props.unlockPageJson.static_text_unlockCaseScreen.unlockCaseScreenSave)}
                </button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
        <UnlockSowModal
          showUnlockModal={this.state.showUnlockSowModal}
          toggleUnlockModal={this.toggleUnlockSowModal}
          translations={this.translations}
          unlockPageJson={this.props.unlockSowModalJson}
          errMsg={this.state.errMsg}
          data={this.state}
          name={this.props.unlockSowModalJson.name}
          handleChange={this.handleChange}
          handleBlur={this.handleBlur}
          displayError={displayError}
          submitUnlockData={this.submitSowUnlockData}
          isDisabled={!this.state[this.props.unlockSowModalJson.name] || this.state[this.props.unlockSowModalJson.name].length === 0}
        />
        <div className="gdocs-clear-both"></div>
        <div>
          <Filter
            pageJson={this.props.pageJson}
            role={this.props.GridData.role}
            glsApprover={this.props.GridData.glsApprover}
            getRoleStatusOnchange={(str) => this.getRoleStatusOnchange(str)}
            getApproverStatusOnchange={(str) => this.getApproverStatusOnchange(str)}
            searchItmeHander={(str) => this.searchItmeHander(str)}
            showFilters={true}
            serchTitleHeader={this.props.pageJson.table_adminList.filterTitle}
            clearFilterText={this.props.pageJson.table_adminList.clearFilterText}
            clearAll={this.resetAll}
            lang={this.props.lang}
          />
          <ReactTable
            data={this.state.data}
            pageJsonContent={this.props.pageJson.table_adminList}
            columns={this.columnsHeader()}
            isCaseList={true}
            defaultPageSize={20}
            dummyRole={(status) => this.dummyRole(status)}
            rowLink={(data) => this.rowLink(data)}
            className="-striped -highlight"
            lang={this.props.lang}
          />
        </div>
        <br />
      </div>
    );
  }
}

const UnlockSowModal = (props) => {
  const { showUnlockModal, toggleUnlockModal, translations, unlockPageJson = {}, errMsg, data, handleChange, name, handleBlur, displayError, submitUnlockData, isDisabled } = props
  return (
    <Modal show={showUnlockModal} onClose={toggleUnlockModal} bsClass="delete-group-model">
      <ModalHeader title={translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowScreenHeading)} />
      <ModalBody>
        <div className="unlock-section">
          <div className="field_row">
            <label className="label-container">
              {translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowId)}
            </label>
            <div className="field-container">
              <input
                className=""
                type="text"
                name={name}
                onBlur={handleBlur(name)}
                value={data[name]}
                onChange={e => { handleChange(e) }}
              />
              {
                data.touched && data.touched[name] && (!data[name] || data[name] === "") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowIdErrorMessage)}
                  </div>
                ) : ''
              }
              {
                errMsg ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowScreenOnlyNumbers)}
                  </div>
                ) : ''
              }
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="delete-group-model--body">
          <div className="gdocs-float-left">
            <button className="gdocs-btn-delete" onClick={toggleUnlockModal}>
              {translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowScreenCancel)}
            </button>
          </div>
          <div className="gdocs-float-right">
            <button className="gdocs-btn-primary" onClick={submitUnlockData} disabled={isDisabled}>
              {translations(unlockPageJson.static_text_unlockSowScreen && unlockPageJson.static_text_unlockSowScreen.unlockSowScreenSave)}
            </button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

UserAdmin.defaultProps = {
  caseSatus: []
}
UserAdmin.propTypes = {
  data: PropTypes.array
};

export default connect(null, mapDispatchToProps)(UserAdmin)



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/UserAdmin.js